"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreBracket = exports.preserveBracket = exports.bracket = void 0;
var preservation_1 = require("./preservation");
exports.bracket = [];
// preserves strings inside square brackets (`[]`)
function preserveBracket(text) {
    return text.replace(/<!--[\s\S]*?-->/g, function (matched) {
        exports.bracket.push(matched);
        return preservation_1.preservation("bracket");
    });
}
exports.preserveBracket = preserveBracket;
// bringing back brackets
function restoreBracket(text) {
    return text.replace(new RegExp("[ ]?" + preservation_1.preservation("bracket").trim() + "[ ]?", "g"), function () { return exports.bracket.shift(); });
}
exports.restoreBracket = restoreBracket;
